export type CohortVariant = 'control' | 'candidate';

// 32-bit FNV-1a hash. Deterministic and dependency-free, so the same key always
// lands in the same bucket across sessions, devices, and (later) the edge and SQL.
function hashString(input: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

/**
 * Deterministic, sticky cohort assignment. `candidatePercent` in [0, 100] is the
 * share of keys routed to `candidate`. The experimentKey namespaces the hash so
 * separate experiments assign the same user independently.
 */
export function assignCohort(
  key: string,
  experimentKey: string,
  candidatePercent: number,
): CohortVariant {
  const clamped = Math.max(0, Math.min(100, candidatePercent));
  const bucket = hashString(`${experimentKey}:${key}`) % 100;
  return bucket < clamped ? 'candidate' : 'control';
}
